import { repository, baseURL } from '@/api/base'

export default {
  async create(body) {
    const { data } = await repository.post(baseURL + '/editorialBoardParticipation', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/editorialBoardParticipation', body)
    return data
  },

  async remove(id) {
    const { data } = await repository.delete(baseURL + `/editorialBoardParticipation/${id}`)
    return data
  },
  async findAll(page, filters = {}) {
    const { data } = await repository.post(baseURL + `/editorialBoardParticipation/findAll/${page}`, filters)
    return data
  },
  async findById(id) {
    const { data } = await repository.get(baseURL + `/editorialBoardParticipation/${id}`)
    return data
  },
  async findActualByEmployeeId(id) {
    const { data } = await repository.get(baseURL + `/editorialBoardParticipation/findByEmployee/${id}`)
    return data
  },

  async findFilterAll(body) {
    const { data } = await repository.post(baseURL + '/editorialBoardParticipationFilter/findAll', body)
    return data
  },
  async findActualizationForCurrentUser() {
    const { data } = await repository.get(baseURL + `/editorialBoardParticipation/findActualizationForCurrentUser`)
    return data
  }
}
